import { DefaultTemplateComponent } from './templates/default/default-template.component';
import { SocialTemplateComponent } from "./templates/social/social-template.component";

export const staticPagesComponentDef = {
    "static-pages": {
        "default": DefaultTemplateComponent,
        "social": SocialTemplateComponent
    }
}